import React, { useState } from 'react';
import { BPForm } from '@common/BPForm';
import { AuthField } from './Common/AuthField';
import { AuthLayout } from './Common/AuthLayout';
import { Button, Header, Message, Segment } from 'semantic-ui-react';
import * as yup from 'yup';
import { authClient } from './authClient';
import { BPButton } from '@/components/bp/bpbutton';

interface ResendEmailConfirmationFormValues {
    email: string;
}

export const ResendEmailConfirmation: React.FC = () => {
    const [submitError, setSubmitError] = useState<string>('');
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const initialValues: ResendEmailConfirmationFormValues = {
        email: ''
    };

    const validationSchema: yup.SchemaOf<ResendEmailConfirmationFormValues> = yup.object().shape({
        email: yup.string()
            .email('Invalid email address')
            .required('Email is required')
    });

    const handleSubmit = async (values: ResendEmailConfirmationFormValues) => {
        setSubmitError('');
        setSuccessMessage('');
        setLoading(true);

        try {
            // Replace with your actual API call
            const result = await authClient.resendEmailConfirmation({ email: values.email });
            if (result.success) {
                setSuccessMessage('Confirmation email sent. Please check your inbox.');
            } else {
                setSubmitError(result.errors?.join(', ') || 'Failed to send confirmation email.');
            }
        } catch (error) {
            setSubmitError('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthLayout>
            <Header as="h1">Resend email confirmation</Header>
            <Header as="h2" size="medium">Enter your email.</Header>
            <Segment>
                {successMessage && (
                    <Message success>
                        {successMessage}
                    </Message>
                )}
                {submitError && (
                    <Message error>
                        {submitError}
                    </Message>
                )}
                <BPForm
                    initialValues={initialValues}
                    vaildationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    hideButtons={true}
                >
                    {(formProps) => (
                        <>
                            <AuthField
                                name="email"
                                label="Email"
                                type="email"
                                autoComplete="email"
                                placeholder="name@example.com"
                            />
                            <BPButton
                                type="submit"
                                primary
                                size="large"
                                fluid
                                disabled={formProps.isSubmitting || loading}
                                loading={formProps.isSubmitting || loading}
                                style={{ marginTop: '1rem' }}
                            >
                                Resend
                            </BPButton>
                        </>
                    )}
                </BPForm>
            </Segment>
        </AuthLayout>
    );
};